
import { useState } from "react";
import { Info } from "lucide-react";

import InfoList from "./InfoList";

import { Button } from "@/components/ui/button";

class Properties {
  postalCode: any;
}

export default function PostalCodeProperties(properties: Properties) {
  const [tab, setTab] = useState('general');

  return (
    <div className="flex min-w-0 max-w-[1400px] flex-col gap-4">
      <div className="min-w-0">
        <p className="text-sm text-muted-foreground">Postleitzahlengebiet</p>
        <h2 className="mt-0.5 break-words text-xl font-bold leading-tight text-[color:var(--customer-primary-dark,hsl(var(--foreground)))] sm:text-2xl">
          {properties.postalCode.postalCode}
        </h2>
      </div>
      {/* Die frühere CommandBar trug genau eine Schaltfläche; als Werkzeugleiste
          aus ui/button bleibt das Verhalten (Klick setzt den Reiter) gleich. */}
      <div role="toolbar" aria-label="" className="flex flex-wrap items-center gap-1 border-b pb-1">
        <Button type="button" variant="ghost" size="sm" className="gap-2" onClick={() => setTab('general')}>
          <Info aria-hidden="true" className="h-4 w-4" />
          <span>General</span>
        </Button>
      </div>
      {(() => {
        switch (tab) {
          case 'general': return <div className="flex min-w-0 flex-col gap-2">
            <h3 className="text-base font-semibold leading-tight">Population</h3>
            <InfoList list={[
              {
                label: 'Total Population',
                value: properties.postalCode.population,
              },]}></InfoList>
          </div>
        }
      })()}
    </div>
  );
}
